var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d6fa59;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M174.33,155.25l6.47-6.47c0-18.91-17.75-34.29-39.57-34.29h-39.77l-6.41,5.59-3.81,27.81,6.41,7.35h76.68Zm-67.22-27.81h34.13c11.87,0,21.95,6.26,25.38,14.87h-61.54l2.04-14.87Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M263.95,191.33l3.97-3.97c0-56.06-42.7-101.67-95.19-101.67H71.96l-6.38,5.4-3.58,21.23H31.36v-24.58h-12.94v31.05l6.47,6.47H59.82l-10.29,61.03,6.38,7.55h13.39v18.43l6.47,6.47h199.34l4.66-10.96-15.83-16.44ZM77.43,98.63h95.3c43.33,0,78.94,36.34,82.03,82.26H63.57l13.87-82.26Zm4.81,107.16v-11.96H248.39l11.51,11.96H82.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIron);
export default __webpack_public_path__ + "static/media/iron.3a400d23db0e0215bae431594787e7ae.svg";
export { ForwardRef as ReactComponent };